import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { ImageViewerComponent } from '../../dialogs/image-viewer/image-viewer.component';

@Component({
  selector: 'view-image-button',
  template: `
    <span>
      <button
        *ngIf="hasImage"
        [disabled]="value.toLowerCase() === 'awaiting_images'"
        mat-button
        vrm-button
        fxFlex
        class="grid-text-centred force grid-text"
        style="color: white; padding-right: 0;"
        (click)="triggerButtonAction()"
      >
        <span *ngIf="value.toLowerCase() === 'images'">
          {{ 'GENERIC.viewImages' | translate }}
        </span>

        <!-- Licence checking -->
        <span *ngIf="value.toLowerCase() === 'view'">
          {{ 'GENERIC.view' | translate }}
        </span>
        <span *ngIf="value.toLowerCase() === 'to_approve'">
          {{ 'GENERIC.toApprove' | translate }}
        </span>
        <span *ngIf="value.toLowerCase() === 'awaiting_images'">
          {{ 'GENERIC.awaitingImages' | translate }}
        </span>
        <span *ngIf="value.toLowerCase() === 'not_approved'">
          {{ 'GENERIC.notApproved' | translate }}
        </span>
      </button>
    </span>
  `,
  styles: [],
})
export class ViewImageButtonComponent implements ICellRendererAngularComp {
  public value: string;
  public licenceDocCount: number;
  public hasImage: boolean = false;

  private readonly imageValueIndicators = [
    'images',

    // Licence checking
    'view',
    'to_approve',
    'awaiting_images',
    'not_approved',
  ];

  constructor(private dialog: MatDialog) {}

  agInit(params: { value: any }) {
    this.value = params.value;

    if (
      params.value &&
      typeof params.value === 'string' &&
      this.imageValueIndicators.includes(params.value.toLowerCase())
    ) {
      setTimeout(() => {
        this.hasImage = true;
      });
    }
  }

  triggerButtonAction() {
    const dialogOptions: MatDialogConfig<any> = {
      height: '100%',
      maxHeight: '100%',

      width: '95%',
      maxWidth: '95%',

      disableClose: true,
    };

    this.dialog.open(ImageViewerComponent, dialogOptions);
  }

  refresh() {
    return false;
  }
}
